export const CREATE_BIRTHDAY_MESSAGE_ON = true;
export const TRIGGER_NOTIFY_SENDER = true;
export const isAllowFreeFormGiftIdeas = true;
export const TRIGGER_GIFT_IDEA_GENERATOR = true;
